export default "__VITE_ASSET__iQy_1OOH__"